export const firebaseConfig = {
  apiKey: "AIzaSyCK2Qt4LyIOwNEEhvAiMuGfkcv75dQigAg",
  authDomain: "prochart-prototype.firebaseapp.com",
  projectId: "prochart-prototype",
  storageBucket: "prochart-prototype.appspot.com",
  messagingSenderId: "423392513970",
  appId: "1:423392513970:web:ac2376cca6205d322d1eab"
};
